module.exports = __webpack_public_path__ + "static/media/confirm-circle-green.5934b636.svg";